import { isDev } from "project-config/utils/env";
import { IBusinessParam } from "@/pages/profile/hooks/useBusinessParam";
import { getUserKey } from "@/utils/getUesrKey";

export function jumpHelper(
  link: string,
  businessParam?: IBusinessParam,
  userType?: number,
  authUnionId?: string
) {
  const host = isDev()
    ? "https://task-pre.renderbus.com"
    : "https://task.renderbus.com";

  const targetLink = `${host}/audit${link}?rsAuthToken=${getUserKey()}&biz=${
    businessParam?.biz
  }&accessId=${businessParam?.accessId}&accountType=${userType}${
    authUnionId ? `&unionId=${authUnionId}` : ""
  }`;

  const windowReference = window.open(targetLink);
  if (windowReference === null) {
    window.location.href = targetLink;
  }
}
